export default "__VITE_ASSET__D50nmxIy__"